import { render } from "./CourierRegiFormUnit.vue?vue&type=template&id=b11580a8"
import script from "./CourierRegiFormUnit.vue?vue&type=script&lang=js"
export * from "./CourierRegiFormUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__